const Templates = {
    english: `hi {{name}}
    // This is a single line comment
    {{name}} this is nums = [10, 20, 30];
    tell {{name}} "Second: " + nums[1];

    /* This is a 
       multi-line comment */
    loop {{name}} ({{name}} this is i = 0; i < 3; i = i + 1) {
        {{name}} this is x = nums[i];
        if {{name}} (x > 15) {
            tell {{name}} "High";
        } otherwise {{name}} if {{name}} (x == 15) {
            tell {{name}} "Medium";
        } otherwise {{name}} {
            tell {{name}} "Low";
        }
    }
bye {{name}}`,
    hindi: `नमस्ते {{name}}
    // यह एक एकल पंक्ति टिप्पणी है
    {{name}} ये है संख्याएं = [10, 20, 30];
    बोलो {{name}} "दूसरा: " + संख्याएं[1];

    /* यह एक 
       बहु-पंक्ति टिप्पणी है */
    चक्र {{name}} ({{name}} ये है i = 0; i < 3; i = i + 1) {
        {{name}} ये है x = संख्याएं[i];
        अगर {{name}} (x > 15) {
            बोलो {{name}} "ज्यादा";
        } वरना {{name}} अगर {{name}} (x == 15) {
            बोलो {{name}} "मध्यम";
        } वरना {{name}} {
            बोलो {{name}} "कम";
        }
    }
अलविदा {{name}}`,
    marathi: `नमस्कार {{name}}
    // ही एक ओळ टिप्पणी आहे
    {{name}} हे आहे संख्या = [10, 20, 30];
    बोल {{name}} "दुसरा: " + संख्या[1];

    /* ही एक 
       बहु-ओळ टिप्पणी आहे */
    आवर्तन {{name}} ({{name}} हे आहे i = 0; i < 3; i = i + 1) {
        {{name}} हे आहे x = संख्या[i];
        जर {{name}} (x > 15) {
            बोल {{name}} "जास्त";
        } तर {{name}} जर {{name}} (x == 15) {
            बोल {{name}} "मध्यम";
        } तर {{name}} {
            बोल {{name}} "कमी";
        }
    }
येतो {{name}}`,
    bengali: `শুরু
    // এটি একটি এক লাইনের মন্তব্য
    ধরি সংখ্যা = [10, 20, 30];
    বলো "দ্বিতীয়: " + সংখ্যা[1];

    /* এটি একটি 
       বহু-লাইন মন্তব্য */
    চক্র (ধরি i = 0; i < 3; i = i + 1) {
        ধরি x = সংখ্যা[i];
        যদি (x > 15) {
            বলো "বেশি";
        } নাহলে যদি (x == 15) {
            বলো "মাঝারি";
        } নাহলে {
            বলো "কম";
        }
    }
শেষ`,
    german: `hallo {{name}}
    // Dies ist ein einzeiliger Kommentar
    {{name}} das ist zahlen = [10, 20, 30];
    sag es {{name}} "Zweite: " + zahlen[1];

    /* Dies ist ein 
       mehrzeiliger Kommentar */
    schleife {{name}} ({{name}} das ist i = 0; i < 3; i = i + 1) {
        {{name}} das ist x = zahlen[i];
        wenn {{name}} (x > 15) {
            sag es {{name}} "Gross";
        } andernfalls {{name}} wenn {{name}} (x == 15) {
            sag es {{name}} "Mittel";
        } andernfalls {{name}} {
            sag es {{name}} "Klein";
        }
    }
tschüss {{name}}`,
    arabic: `أهلاً {{name}}
    // هذا تعليق سطر واحد
    {{name}} هذا هو أرقام = [10, 20, 30];
    تكلم {{name}} "الثاني: " + أرقام[1];

    /* هذا تعليق 
       متعدد الأسطر */
    كرر {{name}} ({{name}} هذا هو i = 0; i < 3; i = i + 1) {
        {{name}} هذا هو x = أرقام[i];
        إذا {{name}} (x > 15) {
            تكلم {{name}} "عالي";
        } وإلا {{name}} إذا {{name}} (x == 15) {
            تكلم {{name}} "متوسط";
        } وإلا {{name}} {
            تكلم {{name}} "منخفض";
        }
    }
    مع السلامة {{name}}`
};

module.exports = Templates;
